import { render, staticRenderFns } from "./WhyBuySection.vue?vue&type=template&id=1c2d66a8&scoped=true&"
import script from "./WhyBuySection.vue?vue&type=script&lang=js&"
export * from "./WhyBuySection.vue?vue&type=script&lang=js&"
import style0 from "./WhyBuySection.vue?vue&type=style&index=0&id=1c2d66a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2d66a8",
  null
  
)

export default component.exports